export function fPhone(value: string | null | undefined): string {
  if (!value) return '';
  const match = /^\+1(\d{3})(\d{3})(\d{4})$/.exec(value.trim());
  return match ? `(${match[1]}) ${match[2]}-${match[3]}` : value;
}
